var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeviceLaptopLtr = function SvgDeviceLaptopLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 35a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.79 24h58.42c2.64 0 4.79 2.185 4.79 4.866v34.268C84 65.815 81.85 68 79.21 68H20.79C18.15 68 16 65.815 16 63.134V28.866C16 26.185 18.15 24 20.79 24m58.42 4.302H20.79c-.3 0-.555.26-.555.564v34.268c0 .305.254.564.555.564h58.42c.3 0 .555-.259.555-.564V28.866a.567.567 0 0 0-.555-.564",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.69 71c1.276 0 2.31 1.12 2.31 2.5 0 1.358-1 2.463-2.248 2.5H8.31C7.035 76 6 74.88 6 73.5c0-1.358 1-2.463 2.248-2.5z"
  })));
};
export default SvgDeviceLaptopLtr;